<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
export default {
  mixins: [Api, Sabit],
  page: {
    title: "Birim Bilgi Güncelleme",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Birim Bilgi Güncelleme",
      items: [
        {
          text: this.$t("ODuyuru.Page.Anasayfa"),
          href: "/",
        },
        {
          text: "Birim Bilgi Güncelleme",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      BirimAdi: null
    };
  },
  watch:{
    BirimAdi(){ 
        this.Get() 
    }
  },

  methods: {
    Get() {
      var Filter = "&Asc=BirimAdi"
      if(this.BirimAdi){ Filter += "&BirimAdi="+this.BirimAdi }
      this.ActionsFilterGet({ Service: "OBirim", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
    MailGuncelle(Data) {
      this.Update("OBirim", Data)
    }
  },
  filters: {
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"> 
                  <b-form-input v-model="BirimAdi"></b-form-input> 
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Birim</th>
                      <th>İyileşiştirme Mail</th>
                      <th>{{ $t("ODuyuru.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.BirimAdi }}</th>
                      <td>
                        <div class="row" v-for="(value, index) in Data.Striyilestirmemail" :key="index">
                          <div class="col-md-10">
                            <b-form-input v-model="Data.Striyilestirmemail[index]"></b-form-input>
                          </div>
                          <div class="col-md-2">
                            <i :key="index" class="fas fa-trash" @click="Data.Striyilestirmemail.splice(index, 1);"></i>
                          </div>
                        </div>
                      </td>

                      <td>
                        <div class="action-is w-100 d-flex justify-content-center align-items-center">
                          <i v-b-tooltip.hover title="Yeni Mail Ekle" :key="index" class="fas fa-plus"
                            @click="Data.Striyilestirmemail.push('test@test.com');"></i>
                          <i v-b-tooltip.hover title="Kaydet" class="fas fa-check-circle"
                            @click="Update('OBirim', Data)"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

    </Layout>
  </Loader>
</template>
